import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const P = '/mang-xa-hoi'

// Lấy bình luận bài viết
export function layBinhLuanBaiViet(postId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${P}/bai-dang/${postId}/binh-luan`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo bình luận
export function taoBinhLuan(postId: number, params: any) {
  try {
    return axiosApi.post(`${P}/bai-dang/${postId}/binh-luan`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật bình luận
export function capNhatBinhLuan(commentId: number, params: any) {
  try {
    return axiosApi.put(`${P}/binh-luan/${commentId}`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy phản hồi (reply) của bình luận
export function layBinhLuanTraLoi(commentId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${P}/binh-luan/${commentId}/tra-loi`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa bình luận
export function xoaBinhLuan(commentId: number) {
  try {
    return axiosApi.delete(`${P}/binh-luan/${commentId}`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
